import { UserPermission } from '../data/models/permission.model';
import { useAppSelector } from './useAppSelector';
import * as userSlice from '../data/user.slice';
import { useHasPermission } from './permissions/useHasPermission';

export function useIsPassengerPortalUser(): boolean {
  const user = useAppSelector(userSlice.selectLoggedInUserInfo);
  const passengerPermission: UserPermission = {
    resource: 'tripleg',
    action: 'readbasic',
    scope: 'member',
  };

  const hasPassengerPermission =
    user && useHasPermission(user, passengerPermission);
  return hasPassengerPermission;
}
